import domReady from '@wordpress/dom-ready';

const DESKTOP_QUERY = '(min-width: 980px)';
const OPEN_DELAY = 150; // ms the pointer must stay before opening.
const CLOSE_DELAY = 300; // ms grace period before closing.

domReady(() => {
  // Pending hover timers, per dropdown.
  const openTimers = new WeakMap();
  const closeTimers = new WeakMap();
  const dropdowns = document.querySelectorAll(
    '.nav-primary .nav-item.dropdown'
  );

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function clearTimer(timers, dropdown) {
    clearTimeout(timers.get(dropdown));
    timers.delete(dropdown);
  }

  function clearTimers(dropdown) {
    clearTimer(openTimers, dropdown);
    clearTimer(closeTimers, dropdown);
  }

  function openDropdown(dropdown) {
    const submenu = dropdown.querySelector('.dropdown__subnav-wrapper');
    const toggle = dropdown.querySelector(
      '.dropdown__toggle[aria-controls="' + submenu.getAttribute('id') + '"]'
    );

    dropdown.classList.add('opened');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', toggle.getAttribute('data-label-close'));
  }

  function closeDropdown(dropdown) {
    const submenu = dropdown.querySelector('.dropdown__subnav-wrapper');
    const toggle = dropdown.querySelector(
      '.dropdown__toggle[aria-controls="' + submenu.getAttribute('id') + '"]'
    );

    dropdown.classList.remove('opened');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open'));
  }

  // Toggle this dropdown and close its siblings (same parent element).
  function toggleDropdown(dropdown) {
    dropdowns.forEach((otherDropdown) => {
      if (otherDropdown === dropdown) {
        clearTimers(dropdown);
        if (dropdown.classList.contains('opened')) {
          closeDropdown(dropdown);
        } else {
          openDropdown(dropdown);
        }
      } else if (otherDropdown.parentElement === dropdown.parentElement) {
        clearTimers(otherDropdown);
        closeDropdown(otherDropdown);
      }
    });
  }

  // Bind every listener once; the mobile/desktop check is done at event time.
  function initDropdowns() {
    dropdowns.forEach((dropdown) => {
      const submenu = dropdown.querySelector('.dropdown__subnav-wrapper');
      const closeBtn = dropdown.querySelector(
        '.dropdown__subnav-wrapper__close'
      );
      const toggle = dropdown.querySelector(
        '.dropdown__toggle[aria-controls="' + submenu.getAttribute('id') + '"]'
      );

      // Mobile: click on the toggle / close button.
      toggle.addEventListener('click', (e) => {
        if (isDesktop()) {
          return;
        }
        e.stopPropagation();
        toggleDropdown(dropdown);
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          if (isDesktop()) {
            return;
          }
          closeDropdown(dropdown);
        });
      }

      // Desktop: keyboard.
      dropdown.addEventListener('keydown', (event) => {
        if (!isDesktop()) {
          return;
        }
        event.stopPropagation();
        if ('Enter' === event.key) {
          toggleDropdown(dropdown);
        }
      });

      // Desktop: hover intent. The submenu is a DOM child of the dropdown,
      // so moving the pointer onto it keeps the dropdown hovered.
      dropdown.addEventListener('mouseenter', () => {
        if (!isDesktop()) {
          return;
        }
        // Pointer is back: cancel a pending close.
        clearTimer(closeTimers, dropdown);
        if (dropdown.classList.contains('opened')) {
          return;
        }
        clearTimer(openTimers, dropdown);
        openTimers.set(
          dropdown,
          setTimeout(() => {
            openTimers.delete(dropdown);
            // Close siblings right away, then open this one.
            dropdowns.forEach((otherDropdown) => {
              if (
                otherDropdown !== dropdown &&
                otherDropdown.parentElement === dropdown.parentElement
              ) {
                clearTimers(otherDropdown);
                closeDropdown(otherDropdown);
              }
            });
            openDropdown(dropdown);
          }, OPEN_DELAY)
        );
      });

      dropdown.addEventListener('mouseleave', () => {
        if (!isDesktop()) {
          return;
        }
        // Pointer left before the open delay elapsed: cancel the open.
        clearTimer(openTimers, dropdown);
        if (!dropdown.classList.contains('opened')) {
          return;
        }
        clearTimer(closeTimers, dropdown);
        closeTimers.set(
          dropdown,
          setTimeout(() => {
            closeTimers.delete(dropdown);
            closeDropdown(dropdown);
          }, CLOSE_DELAY)
        );
      });
    });
  }

  if (0 < dropdowns.length) {
    initDropdowns();
  }
});
